import { render, staticRenderFns } from "./KetuntasanA1.vue?vue&type=template&id=b4a2dee2&scoped=true&"
import script from "./KetuntasanA1.vue?vue&type=script&lang=js&"
export * from "./KetuntasanA1.vue?vue&type=script&lang=js&"
import style0 from "./KetuntasanA1.vue?vue&type=style&index=0&id=b4a2dee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a2dee2",
  null
  
)

export default component.exports